export const RELATIONSHIP_WITH_YOUR_DOG: Record<
	RelationshipWithYourDogScreenNames,
	string
> = {
	RYD_INTRO: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>RELATIONSHIP_WITH_YOUR_DOG</td>
					<td>Q18</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>INTRO</strong>
			</p>
		</div>
	`,

	Q18: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>RELATIONSHIP_WITH_YOUR_DOG</td>
					<td>Q19</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
		</div>
	`,

	Q19: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>RELATIONSHIP_WITH_YOUR_DOG</td>
					<td>Q20</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
			<p>See randomly selected question info below</p>
		</div>
	`,

	Q20: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>RELATIONSHIP_WITH_YOUR_DOG</td>
					<td>Q21</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
			<p>See randomly selected question info below</p>
		</div>
	`,

	Q21: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>IF MORE THAN ONE DOG (They have another dog they can tell us about)</td>
					<td>RELATIONSHIP_WITH_YOUR_DOG</td>
					<td>RYD_MULTI_DOG</td>
				</tr>
				<tr>
					<td>OTHERWISE</td>
					<td>ABOUT_YOU</td>
					<td>AY_INTRO_0</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>OPTIONAL</strong>
			</p>
		</div>
	`,

	RYD_MULTI_DOG: /*html*/ `
		<div>
			<h5>Routing</h5>
			<table>
				<thead>
					<tr>
						<th>Option(s)</th>
						<th>Next Route</th>
						<th>Next Screen</th>
					</tr>
				</thead>

				<tr>
					<td>N/A</td>
					<td>ABOUT_YOU</td>
					<td>AY_INTRO_0</td>
				</tr>
			</table>
			<h5>Other info</h5>
			<p>
				<strong>INTRO</strong>
			</p>
		</div>
	`,
};
